import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.994 29C8.827 28.997 3 23.168 3 16 3 8.83 8.83 3 16 3s13 5.83 13 13c0 7.164-5.82 12.99-12.982 13h-.024M27 16c0 5.73-4.392 10.443-9.99 10.954V19H20c.55 0 1-.45 1-1s-.45-1-1-1h-2.99v-3c0-.27.05-.53.15-.77.1-.25.24-.46.43-.65.19-.18.41-.33.65-.43s.51-.17.77-.15h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.55-.01-1.05.1-1.54.3s-.92.49-1.3.87c-.38.37-.67.81-.87 1.3q-.3.735-.3 1.53v3h-3c-.55 0-1 .45-1 1s.45 1 1 1h3v7.955C9.398 26.449 5 21.733 5 16 5 9.93 9.93 5 16 5s11 4.93 11 11"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconFacebookLogo = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconFacebookLogo);
export default Memo;
